export default __webpack_public_path__ + "assets/Robinhood-8bb867859c30ed1c1ccdf0bf3f89dc39.svg";